import * as React from 'react';
import {Project, ProjectStatus} from '../../../../store/projects/commonTypes';
import {formatDate, formatDateTime, projectStatusOptions} from '../../../../utils/utils';
import CompanyInfo from "../../../company/CompanyInfo";
import PersonInfo from "../../../company/PersonInfo";

const NOT_SPECIFIED: string = 'Ikke spesifisert';

export interface ProjectDetailsFormProps {
    project: Project;
}

export default class ProjectDetails extends React.Component<ProjectDetailsFormProps> {

    private getProjectStatus(project: Project) {
        return projectStatusOptions.filter(_ => _.id == project.projectStatus)[0].label;
    }

    private valueOrDefault(value: any, defaultValue: string = NOT_SPECIFIED) {
        return value ? value : defaultValue;
    }

    public render() {
        return (
            <React.Fragment>
                <div className="details">
                    <div className="row">
                        <div className="col-sm-12 mb-3 d-flex align-items-center">
                            <h4>Prosjektinfo</h4>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Prosjektnummer</span>
                            </div>
                            <div>
                                <span
                                    className="data-value">{this.valueOrDefault(this.props.project.projectNumber)}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Prosjektnavn</span>
                            </div>
                            <div>
                                <span className="data-value">{this.valueOrDefault(this.props.project.name)}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">BREEAM-versjon</span>
                            </div>
                            <div>
                                <span
                                    className="data-value">{this.valueOrDefault(this.props.project.breeamVersion)}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Status</span>
                            </div>
                            <div>
                                <span
                                    className="data-value">{this.valueOrDefault(this.getProjectStatus(this.props.project))}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Registrering dato</span>
                            </div>
                            <div>
                                <span
                                    className="data-value">{this.valueOrDefault(formatDate(this.props.project.registrationDate))}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Kunde på prosjekt</span>
                            </div>
                            <div>
                                {this.props.project.customer ? (
                                    <CompanyInfo company={this.props.project.customer}/>) : (
                                    <span className="data-value">{NOT_SPECIFIED}</span>)}
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Kontaktperson hos kunde/utvikler</span>
                            </div>
                            <div>
                                {this.props.project.contactPerson ? (
                                    <PersonInfo person={this.props.project.contactPerson}/>) : (
                                    <span className="data-value">{NOT_SPECIFIED}</span>)}
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">AP</span>
                            </div>
                            <div>
                                {this.props.project.ap ? (<PersonInfo person={this.props.project.ap!}/>) : (
                                    <span className="data-value">{NOT_SPECIFIED}</span>)}
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Prosjekttype</span>
                            </div>
                            <div>
                                <span
                                    className="data-value">{this.valueOrDefault(this.props.project.projectType)}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Estimert innsendingsdato for prosjekteringsfasesertifisering</span>
                            </div>
                            <div>
                                    <span
                                        className="data-value">{this.props.project.estimatedQaEngineeringDate ? formatDate(this.props.project.estimatedQaEngineeringDate) : NOT_SPECIFIED}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Estimert innsendingsdato for ferdigstillelsesfase-sertifisering</span>
                            </div>
                            <div>
                                    <span
                                        className="data-value">{this.props.project.estimatedQaCompletionDate ? formatDate(this.props.project.estimatedQaCompletionDate) : NOT_SPECIFIED}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Sertifikat prosjektering</span>
                            </div>
                            <div>
                                    <span
                                        className="data-value">{this.props.project.certificateEngineeringDate ? formatDate(this.props.project.certificateEngineeringDate) : NOT_SPECIFIED}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Sertifikat ferdigstillelse</span>
                            </div>
                            <div>
                                    <span
                                        className="data-value">{this.props.project.certificateCompletionDate ? formatDate(this.props.project.certificateCompletionDate) : NOT_SPECIFIED}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 mb-4">
                            <div>
                                <span className="label">Annen relevant informasjon</span>
                            </div>
                            <div>
                                <span
                                    className="data-value">{this.valueOrDefault(this.props.project.comments)}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 mb-4">
                            <div>
                                <span className="label">Skal prosjektets dokumentasjon håndteres konfidensielt?</span>
                            </div>
                            <div>
                                <span
                                    className="data-value">{this.props.project.confidential == true ? 'Ja': 'Nei'}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 mb-4">
                            <div>
                                <span className="label">Kan prosjektet brukes som eksempelprosjekt på våre nettsider?</span>
                            </div>
                            <div>
                                <span
                                    className="data-value">{this.props.project.studyCase == true ? 'Ja': 'Nei'}</span>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 mb-3 d-flex align-items-center">
                            <h4>Bygginfo</h4>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Byggtype</span>
                            </div>
                            <div>
                                <span
                                    className="data-value">{this.valueOrDefault(this.props.project.buildingType)}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Innr/Uinnr.bygg</span>
                            </div>
                            <div>
                                <span
                                    className="data-value">{this.valueOrDefault(this.props.project.furnishedStatus)}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Størrelse</span>
                            </div>
                            <div>
                                <span className="data-value">{this.valueOrDefault(this.props.project.sizeType)}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Bruksareal (m2)</span>
                            </div>
                            <div>
                                <span className="data-value">{this.valueOrDefault(this.props.project.realSize)}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Adresse</span>
                            </div>
                            <div>
                                <span className="data-value">{this.valueOrDefault(this.props.project.address)}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Postnummer</span>
                            </div>
                            <div>
                                <span className="data-value">{this.valueOrDefault(this.props.project.zip)}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Poststed</span>
                            </div>
                            <div>
                                <span className="data-value">{this.valueOrDefault(this.props.project.city)}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Fylke</span>
                            </div>
                            <div>
                                <span className="data-value">{this.valueOrDefault(this.props.project.region)}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Gårdsnummer</span>
                            </div>
                            <div>
                                <span
                                    className="data-value">{this.valueOrDefault(this.props.project.gardenNumber)}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Bruksnummer</span>
                            </div>
                            <div>
                                <span className="data-value">{this.valueOrDefault(this.props.project.useNumber)}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Bygningsnummer</span>
                            </div>
                            <div>
                                <span
                                    className="data-value">{this.valueOrDefault(this.props.project.buildingNumber)}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Antall bygninger</span>
                            </div>
                            <div>
                                <span
                                    className="data-value">{this.valueOrDefault(this.props.project.amountOfBuildings)}</span>
                            </div>
                        </div>
                        {this.props.project.numberOfAppartments && (
                            <div className="col-sm-12 col-md-3 mb-4">
                                <div>
                                    <span className="label">Antall boenheter</span>
                                </div>
                                <div>
                                <span
                                    className="data-value">{this.valueOrDefault(this.props.project.numberOfAppartments)}</span>
                                </div>
                            </div>
                        )}

                    </div>

                    <div className="row">
                        <div className="col-sm-12 mb-3 d-flex align-items-center">
                            <h4>Fakturainfo</h4>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 col-md-6 mb-4">
                            <div>
                                <span className="label">Revisors fakturaadresse (e-post eller EHF)</span>
                            </div>
                            <div>
                                <span
                                    className="data-value">{this.valueOrDefault(this.props.project.invoiceEmail)}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 mb-4">
                            <div>
                                <span className="label">Faktura merkes med evt. referanse/ordre/prosjekt-nummer</span>
                            </div>
                            <div>
                                <span
                                    className="data-value">{this.valueOrDefault(this.props.project.invoiceNumber)}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}